
import { iconsDetailsProyect } from "../../../../assets/icons/detailsProject";
import { CalendarInfo } from "../../../../components/Dates/CalendarInfo";
import { typeForDetailsProyect } from "../../../../types/typeModalDetailsProject";
import CardProjectFiche from "./CardProjectFiche";


const CardCalendar = ({ isSuperAdmin, isAdmin, pauses, dates, activeModalDetailsProject }) => {
    return (
        <CardProjectFiche
            title="Calendario"
            enableButtonExtra={isSuperAdmin || isAdmin}
            buttonExtra={
                <div
                    onClick={() => {
                        activeModalDetailsProject(typeForDetailsProyect.calendar);
                    }}
                    className="h-full w-[15px] cursor-pointer"
                >
                    <img className="h-full w-full object-contain" src={iconsDetailsProyect.editbutton} alt="edit" />
                </div>
            }
        >
            <div className="h-[520px]">
                <CalendarInfo
                    pauses={pauses}
                    dates={{
                        today: dates.today,
                        start: dates.start,
                        concluedDate: dates.finished,
                        expectDate: dates.expected,
                        deadline: dates.deadLine,
                    }}
                />
            </div>
        </CardProjectFiche>
    );
};

export default CardCalendar;
